<div class="modal-error">
  <div class="modal-icon">
    <img [src]="icon" alt="fail Print" />
  </div>

  <div>
    <div style="text-align: center">
      <span class="main-txt">{{ mainCopy | translate }}</span>
    </div>
    <div style="text-align: center">
      <span class="txt-second" [innerHTML]="'errorRecipt.txtsecond' | translate"> </span>
    </div>
  </div>

  <button class="btn-accept" (click)="onAcceptClick()">
    {{ 'modalPremierDisclaimer.button' | translate }}
  </button>
</div>
